module.exports = __webpack_public_path__ + "img/11088036_L.df59f562.png";